import React from "react";

import { cn } from "@/web/lib/styling";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        ref={ref}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            (e.target as HTMLInputElement).blur();
          }
        }}
        data-slot="withus-input"
        className={cn(
          // Load-bearing: mobile font must be >=16px so iOS Safari doesn't zoom on focus. Don't shrink below text-base under md.
          "flex h-input w-full min-w-0 rounded-none border bg-input px-3 py-2 text-base text-input-foreground md:text-sm",
          "outline-none placeholder:text-input-foreground/40 disabled:pointer-events-none",
          "disabled:cursor-not-allowed disabled:bg-black/5 disabled:text-withus-dark-blue/50",
          "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50",
          className,
        )}
        {...props}
      />
    );
  },
);

Input.displayName = "Input";

export { Input };
